export const rideStatusLabels: Record<string, string> = {
  requested: 'Demandée',
  searching: 'Recherche agent',
  assigned: 'Assignée',
  accepted: 'Acceptée',
  en_route_pickup: 'Vers départ',
  picked_up: 'Récupérée',
  en_route_delivery: 'En livraison',
  delivered: 'Livrée',
  completed: 'Terminée',
  cancelled: 'Annulée',
  expired: 'Expirée',
};

export const rideStatusColors: Record<string, string> = {
  requested: 'badge-gray',
  searching: 'badge-warning',
  assigned: 'badge-primary',
  accepted: 'badge-primary',
  en_route_pickup: 'badge-warning',
  picked_up: 'badge-warning',
  en_route_delivery: 'badge-warning',
  delivered: 'badge-success',
  completed: 'badge-success',
  cancelled: 'badge-error',
  expired: 'badge-gray',
};

export const rideTypeLabels: Record<string, string> = {
  delivery: 'Livraison',
  errand: 'Course',
  meal: 'Repas',
  package: 'Colis',
};

export const userStatusLabels: Record<string, string> = {
  pending: 'En attente',
  active: 'Actif',
  suspended: 'Suspendu',
  blocked: 'Bloqué',
};

export const userStatusColors: Record<string, string> = {
  pending: 'badge-warning',
  active: 'badge-success',
  suspended: 'badge-error',
  blocked: 'badge-error',
};

export function formatFcfa(value: number): string {
  return `${Number(value || 0).toLocaleString('fr-FR')} FCFA`;
}

export function formatDate(value: string): string {
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}
